import { render, staticRenderFns } from "./KazangVcdSelector.vue?vue&type=template&id=2c701f48&scoped=true&"
import script from "./KazangVcdSelector.vue?vue&type=script&lang=js&"
export * from "./KazangVcdSelector.vue?vue&type=script&lang=js&"
import style0 from "./KazangVcdSelector.vue?vue&type=style&index=0&id=2c701f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c701f48",
  null
  
)

export default component.exports